import { render, staticRenderFns } from "./Bigcoffeegatheringdetails.vue?vue&type=template&id=5d87e6cf&scoped=true&"
import script from "./Bigcoffeegatheringdetails.vue?vue&type=script&lang=js&"
export * from "./Bigcoffeegatheringdetails.vue?vue&type=script&lang=js&"
import style0 from "./Bigcoffeegatheringdetails.vue?vue&type=style&index=0&id=5d87e6cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87e6cf",
  null
  
)

export default component.exports